import { createContext } from 'react';
import { UserProfileDTO } from './service-dto/me-to-profile';

const doNothing = data => Promise.resolve(data);

export const UserProfileContext = createContext({
  updateProfile: doNothing,
  currentUserProfile: UserProfileDTO.default(),
});
